export default "__VITE_ASSET__CorVkfw0__"